module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/OGUNN3/tc-custom/9781440528866.jpg?1730536015097",
      "alt": "This image is the cover for the book Everything Parent's Guide to Eating Disorders, The Everything Books"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Everything Parent's Guide to Eating Disorders, The Everything Books\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('i', [_vm._v("You don't know what to do")]), _vm._v(". Your once happy, carefree child has begun abusing food and fallen into a pattern of disordered eating that is literally taking her life. You watch in horror as she binges and purges, starves herself, compulsively eats, or takes pills and supplements. There is no such thing as a harmless eating disorder. Your child is in danger and she needs your help."), _c('br'), _c('br'), _vm._v("Children with an eating disorder need their parents to be prepared, engaged, knowledgeable, and ready to do battle on their behalf. With the professional, accessible advice presented here, you can get the support you need."), _c('br'), _c('br'), _vm._v("This guide helps you:"), _c('br'), _vm._v("Promote positive body image--at any ageInstill healthy eating habitsRecognize warning signsFind the right treatment optionsStay positive and encourage your child"), _c('br'), _vm._v("This book provides an all-encompassing look at eating disorders--the symptoms, the causes, and the treatments--so you can feel confident about the steps you need to take to help your child overcome this illness.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Angie Best-Boss\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Adams Media\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0